import { LinkBubbleMenu } from "@/components/tiptap-ui/link-popover/link-bubble-menu";
import { TiptapCollabProvider } from "@hocuspocus/provider";
import { Editor, EditorContent } from "@tiptap/react";
import { PageBody } from "../app-layout";
import { Column } from "../ui/flex";
import { Skeleton } from "../ui/skeleton";
import { VersionHistory } from "./use-collab-editor";
import { VersionHistoryPanel } from "./VersionHistoryPanel";
import { WriterBubbleMenu } from "./WriterBubbleMenu";
import { WriterThreadPopup } from "./WriterThreadPopup";
import { useWriterThreadsContext } from "./WriterThreadsContext";
import { WriterToolbar } from "./WriterToolbar";

interface WriterContentProps {
  editor: Editor | null;
  provider: TiptapCollabProvider | null;
  isConnected: boolean;
  versionHistory: VersionHistory;
  onBackgroundClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export const WriterContent: React.FC<WriterContentProps> = ({
  editor,
  provider,
  isConnected,
  versionHistory,
  onBackgroundClick,
}) => {
  const { selectedThreadId } = useWriterThreadsContext();

  return (
    <>
      <WriterToolbar>
        {editor && (
          <VersionHistoryPanel
            editor={editor}
            provider={provider}
            versions={versionHistory.versions}
          />
        )}
      </WriterToolbar>
      <PageBody document onClick={onBackgroundClick}>
        <div className="pl-3">
          {isConnected ? (
            <>
              {/*
              The Bubble Menu needs to be a sibling to the Editor Content.
              I have wasted too many hours on this very cryptic issue.

              The error you will be getting:
              NotFoundError: Failed to execute 'insertBefore' on 'Node': The node before which the new node is to be inserted is not a child of this node.
            */}
              <WriterBubbleMenu />
              <LinkBubbleMenu editor={editor} />
              <EditorContent className="markdown" editor={editor} />
            </>
          ) : (
            <LoadingSkeleton />
          )}
        </div>
      </PageBody>
      {selectedThreadId && <WriterThreadPopup />}
    </>
  );
};

const LoadingSkeleton: React.FC = () => {
  return (
    <Column className="gap-2">
      <Skeleton className="h-6 w-20" />
      <Skeleton className="h-4 w-80" />
      <Skeleton className="h-4 w-80" />
      <Skeleton className="h-4 w-90" />
      <Skeleton className="mt-4 h-6 w-20" />
      <Skeleton className="h-4 w-40" />
      <Skeleton className="h-4 w-80" />
    </Column>
  );
};
